import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {DialogWidth, SessionService, SnackBarService, UserTeam} from '@q9elements/ui-kit/common';
import {filter} from 'rxjs';

import {InviteUserDialogComponent} from '../../spaces/dialogs/invite-user-dialog/invite-user-dialog.component';
import {
  InviteUserOrBatchApiPayload,
  InviteUsersBatchApiPayload
} from '../../spaces/models/spaces.interface';
import {SpacesDaoService} from '../../spaces/services/spaces-dao.service';

@Injectable({
  providedIn: 'root'
})
export class SpaceInviteService {
  constructor(
    private sessionService: SessionService,
    private spacesDaoService: SpacesDaoService,
    private dialog: MatDialog,
    private snackBarService: SnackBarService
  ) {}

  openInviteForCurrentSpaceDialog(): void {
    const user = this.sessionService.user();
    const space = (user?.userInTeam as UserTeam) || null;

    if (!space) {
      return;
    }

    const onSubmit = (id: string, data: InviteUserOrBatchApiPayload) => {
      if ('emails' in data) {
        return this.spacesDaoService.inviteUsersBatch(id, data as InviteUsersBatchApiPayload);
      }

      return this.spacesDaoService.inviteUser(id, data);
    };

    this.dialog
      .open(InviteUserDialogComponent, {
        width: DialogWidth.LG,
        data: {space, onSubmit}
      })
      .afterClosed()
      .pipe(filter(Boolean))
      .subscribe({
        next: () => {
          this.snackBarService.open('USER.INVITE_USER_SENT');
        },
        error: error => {
          this.snackBarService.open(error);
        }
      });
  }
}
